import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_ONBOARDING_CONFIGURATION, GET_ONBOARDING_CONFIGURATION_SUCCESS, GET_ONBOARDING_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getOnboardingConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/configuration/${payload?.id}`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_ONBOARDING_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ONBOARDING_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ONBOARDING_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchGetOnboardingConfiguration() {
  yield takeEvery(GET_ONBOARDING_CONFIGURATION, getOnboardingConfiguration);
}

function* getOnboardingConfigurationSaga() {
  yield all([fork(watchGetOnboardingConfiguration)]);
}

export default getOnboardingConfigurationSaga;
